import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerSeven from "../components/DashBoardLayerSeven";


const HomePageSeven = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Patient profile" />

        {/* DashBoardLayerSeven */}
        <DashBoardLayerSeven />

      </MasterLayout>
    </>
  );
};

export default HomePageSeven;
